import React, { useState } from "react";
import {
    Stack,
    Button,
    TextField
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { insertIssue } from "../../../../../store/slices/pipelines";

const ReportIssue = ({ entityId, data, dataLabel, entityType, issueType, isOpenIssues }) => {
    const dispatch = useDispatch();
    const [issueDescription, setIssueDescription] = useState(null);

    const onSaveIssue = () => {
        const input = { EntityType: entityType, EntityId: entityId, IssueType: issueType, Description: issueDescription, Data: data };
        dispatch(insertIssue(input, isOpenIssues))
    }

    return (
        <Stack>
            <TextField
                multiline rows={4}
                sx={{ width: "100%", }}
                type="text"
                label="Description"
                variant="outlined"
                value={issueDescription}

                onChange={(e) => setIssueDescription(e.target.value)}
            />
            <TextField
                disabled
                // multiline rows={3}
                sx={{ width: "100%", mt: (theme) => theme.spacing(2), }}
                className='text-muted'
                type="text"
                label={dataLabel}
                variant="outlined"
                value={data}

                onChange={(e) => setIssueDescription(e.target.value)}
            />
            <Button
                color="primary"
                variant="contained"
                sx={{ mt: (theme) => theme.spacing(2), minWidth: '80px', alignSelf: 'flex-end' }}
                disabled={issueDescription==null||issueDescription==''}
                onClick={(e) => onSaveIssue()}
            >
                Report Issue
            </Button>

        </Stack>

    );
};

export default ReportIssue;